import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeViewerOption } from 'src/types/shared/User';

export const populateCreateChallengeGroupViewersRequest = createAction(
    'populateCreateChallengeGroupViewersRequest',
);
export const populateCreateChallengeGroupViewersSuccess = createAction<ChallengeViewerOption[]>(
    'populateCreateChallengeGroupViewersSuccess',
);
export const populateCreateChallengeGroupViewersFailure = createAction(
    'populateCreateChallengeGroupViewersFailure',
);

export const populateCreateChallengeGroupViewers = () => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(populateCreateChallengeGroupViewersRequest());
    try {
        const { data } = await api.get<ChallengeViewerOption[]>(
            `admin/challengegroups/populate-create-viewers`,
        );
        dispatch(populateCreateChallengeGroupViewersSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, populateCreateChallengeGroupViewersFailure, e);
    }
};
